import { Footer } from "@components/Footer";
import { Header } from "@components/Header";
import PaymentDetailPopup from "@components/Popup/PaymentDetail";
import { UserContext } from "@context/UserContext";
import { ReactComponent as ChevronLeftIcon } from "@svg/ChevronLeft.svg";
import { ReactComponent as ChevronRightIcon } from "@svg/ChevronRight.svg";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GetAllPaymentsRes, Payment, cancelTossPmntOrder, getAllPayments } from './paymentService'; // paymentService에서 Payment 및 관련 타입 가져오기

export const Charged = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userId, chargeLog, getChargeLog, chargeLogCnt, session_token } = useContext(UserContext);
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState<any>(chargeLog);
  const [isOpen, setIsOpen] = useState<any>(undefined);
  const [selectedItem, setSelectedItem] = useState<any>(undefined);
  const [isHoveredIndex, setIsHoveredIndex] = useState<number>(-1);
  const [tossPayments, setTossPayments] = useState<Payment[]>([]); // State for Toss payments

  useEffect(() => {
    getChargeLog({ page: page, count: 5, token: session_token });
  }, [page]);

  useEffect(() => {
    if (chargeLogCnt === 0) {
      setPage(prev => prev - 1);
    } else {
      setData(chargeLog);
    }
  }, [chargeLog, chargeLogCnt]);

  useEffect(() => {
    if (userId && userId <= -1) navigate("/login");
  }, [userId]);

  useEffect(() => {
    fetchPayments(); // Fetch Toss payments on component mount
  }, []);
  
  useEffect(() => {
    console.log("Session Token:", session_token);
  }, [session_token]);

  const fetchPayments = async () => {
    if (!session_token) {
      console.error('Session token is undefined');
      return;
    }

    try {
      const result: GetAllPaymentsRes = await getAllPayments({
        startDate: '2023-01-01',
        endDate: '2024-12-31',
        page: 1,
        count: 20,
        token: session_token, // 여기서 session_token 사용
      });

      console.log('Fetched payments result:', result); // Log the result to check its structure
      if (result && result.data && result.data.list && result.data.list.length > 0) {
        const appPayments = result.data.list.filter(payment => payment.platform !== 'web' && payment.platform !== 'toss');
        console.log('Toss 결제 정보 필터링:', appPayments);
        setTossPayments(appPayments); // 필터된 Toss 결제 상태 업데이트
      } else {
        console.error('결제 정보 가져오기 오류: 결제 정보 없음');
      }
    } catch (error) {
      console.error('결제 정보 가져오기 오류:', error);
    }
  };

  const clickNext = useCallback(() => {
    if (data.length >= 5) {
      setPage(page + 1);
    }
  }, [data, page]);

  const handleMouseEnter = (index: number) => {
    setIsHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setIsHoveredIndex(-1);
  };

  const handleItemClick = (item: any) => {
    setSelectedItem(item);
    setIsOpen(true);
  };

  const handleCancelPayment = async (paymentKey: string, orderId: string) => {
    if (!session_token) {
      console.error('Session token is undefined');
      return;
    }

    try {
      await cancelTossPmntOrder({ paymentKey, orderId, cancel_reason: '고객요청', token: session_token });
      alert('결제가 취소되었습니다.');
      navigate('/'); // Navigate to the home page or another page after cancellation
    } catch (error) {
      console.error('결제 취소 오류:', error);
      alert('결제 취소 중 오류가 발생했습니다.');
    }
  };

  return (
    <div className="">
      {isOpen && (
        <PaymentDetailPopup isOpen={isOpen} setIsOpen={setIsOpen} selectedItem={selectedItem} />
      )}
      <div className="h-[10rem] max-lg:h-[6rem]">
        <Header />
      </div>
      <div className="flex flex-col">
        <div className="mx-auto max-w-[1200px] w-full px-[8rem] max-header:px-4">
          <div
            className="text-center mt-1 text-sm"
            style={{
              fontFamily: "'Noto Sans KR', sans-serif",
            }}
          >
            <div className="relative flex flex-row mb-8">
              <div className="flex flex-row leading-24 justify-center items-center">
                <p className="text-black font-bold text-2xl">충전내역</p>
              </div>
            </div>
            {data?.map((item: any, index: number) => (
              <Content
                key={index}
                item={item}
                setIsOpen={setIsOpen}
                setSelectedItem={setSelectedItem}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
                isHovered={isHoveredIndex === index}
                onItemClick={() => handleItemClick(item)}
              />
            ))}

            {tossPayments?.map((item: Payment, index: number) => (
              <Content
              key={`toss-${index}`}
              item={item}
              setIsOpen={setIsOpen}
              setSelectedItem={setSelectedItem}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              isHovered={isHoveredIndex === index}
              onItemClick={() => handleItemClick(item)}
              onCancel={() => handleCancelPayment(item.id, item.orderId)} // 결제 취소 핸들러에 적절한 paymentKey 및 orderId 전달
              />
            ))}
          </div>
          <div className="flex ml-auto my-3 flex-row w-24">
            <button
              className="bg-[#F7F7F7] px-2 py-2 rounded-[8px] border-[2px] border-solid ml-auto font-notokr text-[16px] font-medium text-[#757575] hover:bg-[#e0e0e0] hover:text-black"
              onClick={() => {
                if (page > 1) setPage(page - 1);
              }}
            >
              <ChevronLeftIcon className="w-4 h-4" />
            </button>
            <button
              className="bg-[#F7F7F7] px-2 py-2 rounded-[8px] border-[2px] border-solid ml-auto font-notokr text-[16px] font-medium text-[#757575] hover:bg-[#e0e0e0] hover:text-black"
              onClick={clickNext}
            >
              <ChevronRightIcon className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
      <div className="h-[15rem] max-lg:h-[6rem]">
        <Footer />
      </div>
    </div>
  );
};


const Content = ({
  item,
  setIsOpen,
  setSelectedItem,
  onMouseEnter,
  onMouseLeave,
  isHovered,
  onItemClick,
  onCancel
}: {
  item: any; // Payment 타입으로 지정
  setIsOpen: any;
  setSelectedItem: any;
  onMouseEnter: any;
  onMouseLeave: any;
  isHovered: any;
  onItemClick: any;
  onCancel?: any;
}) => {
  return (
    <div
      className={`cursor-pointer ${isHovered ? 'bg-blue-200' : ''}`}
      onClick={onItemClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="flex flex-row items-center my-3 px-4">
        <div className="flex flex-row w-full justify-between max-sm:flex-col">
          <div className="flex flex-col font-notokr text-left gap-1">
            {item.payments && (
              <div className="flex flex-row gap-7 text-[#000000]">
                <div> {item.createdAt}</div>
                <div>카드사: {item.payments.acquirerCode}</div>
                <div>카드번호: {item.payments.number}</div>
                <div>카드종류: {item.payments.cardType}</div>
         
                <div>{item.default_coin + item.bonus_coin} ContentCoin</div> {/* 여기에 추가 */}
              </div>
            )}
          </div>
          <div className="flex flex-row items-center text-right gap-3 text-sm">
            {item.Status === 1 && item.payments && (
              <>
                <div className="text-red-400"> {item.payments.cardAmount} 원</div>
                <span className="text-green-500">결재완료</span>
              </>
            )}
            {item.Status === 2 && item.payments && (
              <>
                <div className="text-red-400"> {item.payments.cardAmount} 원</div>
                <span className="text-red-500">결재취소</span>
              </>
            )}
          </div>
          {/* {onCancel && item.Status === 1 && (
            <button
              className="ml-4 bg-red-500 text-white px-4 py-2 rounded"
              onClick={(e) => {
                e.stopPropagation(); // Prevents the click event from propagating to the parent div
                onCancel();
              }}
            >
              결제 취소
            </button>
          )} */}
        </div>
      </div>
    </div>
  );
};
